import {use} from 'react';

import {TVehicleCreateContext} from '../types/TVehicleCreateContext';
import {VehicleCreate} from '../VehicleCreateCtx';

export const useVehicleCreateContext = (): TVehicleCreateContext => use(VehicleCreate);
